import api from '@/api'
export default {
  // 获取不同状态的比赛报告列表-GET-可分页-系统管理员/技术支持调用
  getMatchReportListSystem (params) {
    return api({
      url: '/match/matchReportPageSystem',
      method: 'GET',
      params
    })
  },
  // 获取不同状态的比赛报告列表-GET-可分页-会员协会调用
  getMatchReportListOrgan (params) {
    return api({
      url: '/match/matchReportPageOrgan',
      method: 'GET',
      params
    })
  },
  // 获取不同状态的比赛报告列表-GET-可分页-青训中心调用
  getMatchReportListYouth (params) {
    return api({
      url: '/match/matchReportPageYouth',
      method: 'GET',
      params
    })
  },
  // 获取不同状态的比赛报告列表-GET-可分页-教练/领队调用
  getMatchReportListCoach (params) {
    return api({
      url: '/match/matchReportPageCoach',
      method: 'GET',
      params
    })
  },
  // 删除比赛报告
  recordMatchReport (matchReportUuid) {
    return api({
      url: `/match/recordMatchReport/${matchReportUuid}`,
      method: 'DELETE',
    })
  },
  // 退回比赛报告
  backMatchReport (matchReportUuid) {
    return api({
      url: `/match/backMatchReport/${matchReportUuid}`,
      method: 'GET',
    })
  },

  // 第一步:比赛报告-回显
  matchReportInfo (matchReportUuid) {
    return api({
      url: `/match/matchReportInfo/${matchReportUuid}`,
      method: 'GET'
    })
  },

  // 第一步:编写比赛报告-保存-文件创建用
  FirstMatchReport (data) {
    return api({
      url: '/match/matchStepOne',
      method: 'POST',
      data
    })
  },

  // 第二步:比赛报告-获取比赛报告详情
  matchCommentInfo (matchReportUuid) {
    return api({
      url: '/match/matchCommentInfo',
      method: 'GET',
      params: { matchReportUuid: matchReportUuid }
    })
  },
  // 第二步:比赛报告评价-保存球员信息
  saveMatchPlayer (data) {
    return api({
      url: '/match/savePlayerInfo',
      method: 'POST',
      data
    })
  },

  // 获取完成状态比赛报告的详细信息
  getMatchReportDetail (matchReportUuid) {
    return api({
      url: `/match/infoMatchReportCompleteStatus/${matchReportUuid}`,
      method: 'GET'
    })
  },

  // 下载比赛报告PDF
  downloadMatchReport (matchReportUuid) {
    return api({
      url: `/match/matchReportDownLoadPdf/${matchReportUuid}`,
      method: 'GET',
    })
  },


  // 获取不同状态的比赛报告列表-GET-可分页-教练/领队调用
  getMatchReportListToPlayer (params) {
    return api({
      url: '/match/matchReportListToPlayer',
      method: 'GET',
      params
    })
  },
  
  matchTournamentTwoInfo (tournamentUuid ) {
    return api({
      url: `/match/matchTournamentTwoInfo/${tournamentUuid}`,
      method: 'GET'
    })
  },
  matchTournamentInfo (tournamentUuid ) {
    return api({
      url: `/match/matchTournamentInfo/${tournamentUuid}`,
      method: 'GET'
    })
  },
  matchTournamentThreeInfo (tournamentUuid) {
    return api({
      url: `/match/matchTournamentThreeInfo/${tournamentUuid}`,
      method: 'GET'
    })
  },
  // 第一步:编写赛事
  FirstMatchReportTournament (data) {
    return api({
      url: '/match/tournamentStepOne',
      method: 'POST',
      data
    })
  },
  // 第二步:编写赛事
  TwoMatchReportTournament (data) {
    return api({
      url: '/match/tournamentStepTwo',
      method: 'POST',
      data
    })
  },
  // 第三步:编写赛事
  ThreeMatchReportTournament (data) {
    return api({
      url: '/match/tournamentStepThree',
      method: 'POST',
      data
    })
  },
  
  // 获取不同状态的比赛报告列表-GET-可分页-系统管理员/技术支持调用
  getMatchReportListSystemTournament (params) {
    return api({
      url: '/match/tournamentReportPageSystem',
      method: 'GET',
      params
    })
  },
  // 获取不同状态的比赛报告列表-GET-可分页-会员协会调用
  getMatchReportListOrganTournament (params) {
    return api({
      url: '/match/tournamentReportPageOrgan',
      method: 'GET',
      params
    })
  },
  // 获取不同状态的比赛报告列表-GET-可分页-青训中心调用
  getMatchReportListYouthTournament (params) {
    return api({
      url: '/match/tournamentReportPageYouth',
      method: 'GET',
      params
    })
  },
  // 获取不同状态的比赛报告列表-GET-可分页-教练/领队调用
  getMatchReportListCoachTournament (params) {
    return api({
      url: '/match/tournamentReportPageCoach',
      method: 'GET',
      params
    })
  },
  // 删除比赛报告
  recordMatchReportTournamentDeleted (tournamentUuid) {
    return api({
      url: `/match/recordTournamentReport/${tournamentUuid}`,
      method: 'POST',
    })
  },
  // 获取完成状态比赛报告的详细信息
  getMatchReportDetailTournament (tournamentUuid) {
    return api({
      url: `/match/infoTournamentReportCompleteStatus/${tournamentUuid}`,
      method: 'GET'
    })
  },
  // 获取完成状态比赛报告的详细信息
  backTournamentReport (tournamentUuid) {
    return api({
      url: `/match/backTournamentReport/${tournamentUuid}`,
      method: 'POST'
    })
  },
}
